export const VALIDATION_ERROR_MESSAGE = {
  INVALID_MOBILE_NUMBER: 'Please enter a valid mobile number. e.g. 04XX XXX XXX',
  ENTER_A_VALID_CODE: 'Please enter a valid verification code.',
  INVALID_PASSWORD: 'Your current password is incorrect, please try again.',
  NEW_PASSWORD_NOT_OLD: 'Your password must not be the same as old password.',
  INVALID_CONFIRM_PASSWORD: 'Please ensure new password and confirmation password are the same.',
  PASSWORD_MUST_CONTAIN_DIGIT: 'Your password must contain a number.',
  PASSWORD_MUST_CONTAIN_UPPERCASE: 'Your password must contain an uppercase letter.',
  PASSWORD_MUST_BE_MIN_8_CHARACTERS: 'Your password must not be less than 8 characters.',
  PASSWORD_MUST_NOT_CONTAIN_PASSWORD:
    'Your password must be unique and should not contain the word "password". Please choose another password.',
  REQUIRED: 'This field is required.',
  REQUIRED_INVOICE: 'Please upload at least one invoice.',
  REQUIRED_VET_NOTES: 'Please upload at least one set of vet consultation notes.',
  MAX_FILE_COUNT:
    'Sorry, we experienced a problem uploading this file. Please try again or contact us for assistance. Tip: Maximum 8 files allowed and must be a PDF or image file.',
  UNSUPPORTED_FILE_TYPE: 'Sorry, this file type is not supported. Only PDFs and images are allowed.',
  INVALID_ADDRESS: 'Please enter a valid address.'
};

export const ALERT_ERROR_MESSAGE = {
  INVALID_VERIFICATION_CODE: 'Please enter the 6-digit verification code or click the resend code button.',
  TOO_MANY_SMS_ATTEMPTS: 'Too many SMS code requests. Please try again in 60 minutes.',
  TOO_MANY_EMAIL_ATTEMPTS: 'Too many email code requests. Please try again in 60 minutes.',
  ERROR_OCCURRED: 'An error occurred with your request. Please try again.',
  SIGN_UP_NO_MOBILE_NUMBER: (phoneNumber) =>
    `We are unable to continue with sign up as we do not have a mobile phone number on record to secure your account. Please call us on ${phoneNumber} for assistance.`
};

export const GENERIC_API_ERROR_MESSAGE = 'Something went wrong while processing your request. Please try again later.';
export const AUTH0_ERROR_MESSAGE = {
  ACCESS_DENIED: 'user is not enrolled in preferred authenticator',
  USER_BLOCKED: 'user is blocked'
};
